<template>
	<v-hover>
		<template>
			<v-btn
				class="botao-primario"
				:class="{ 'botao-primario--icone': icone, 'botao-cancelar__tamanho-largura': !tamanhoLargura }"
				:style="{ width: tamanhoLargura + 'px' }"
				:color="corDeFundo"
				:icon="!nomeBotao"
				:outlined="outlined"
				dense
				:block="block"
				:dark="dark"
				:disabled="disabled"
				@click="trataAcaoDeBotaoDesabilitado(() => $emit('click'))"
			>
				<v-icon v-show="icone" :size="tamanhoIcone" :color="corIcone" class="me-1">{{ icone }}</v-icon>

				<div v-show="nomeBotao">
					{{ nomeBotao }}
				</div>
			</v-btn>
		</template>
	</v-hover>
</template>

<script>
import trataAcaoDeBotaoDesabilitado from '@/views/mixins/trataAcaoDeBotaoDesabilitado'

export default {
	name: 'botao-primario',
	mixins: [trataAcaoDeBotaoDesabilitado],
	props: {
		nomeBotao: {
			type: String,
			default: '',
		},
		corDeFundo: {
			type: String,
			default: 'primary',
		},
		dark: {
			type: Boolean,
		},
		icone: {
			type: String,
			default: '',
		},
		tamanhoIcone: {
			type: String,
			default: '0.9rem',
		},
		corIcone: {
			type: String,
			default: 'var(--v-accent-lighten5)',
		},
		outlined: {
			type: Boolean,
		},
		block: {
			type: Boolean,
		},
		tamanhoLargura: {
			type: String,
			default: null,
		},
	},
	emits: ['click'],
}
</script>

<style lang="stylus">
button.theme--light.v-btn.v-btn--disabled.v-btn--has-bg.botao-primario:disabled
	background-color #ccc !important
	color #888 !important
	cursor not-allowed

.botao-primario
	font-size (13 / 16)rem !important

	&__tamanhoLargura
		min-width 6.25rem !important;

.botao-primario.botao-primario--icone
	min-width (70 / 16)rem !important

	.v-btn__content
		justify-content normal !important
</style>
